import { styled } from '@streamelements/frontend-ui';
import { Tooltip, TooltipContent, TooltipTrigger } from '../Tooltip';
import { VerticalOutputIcon } from '../Icons/VerticalOutputIcon';
import { HorizontalOutputIcon } from '../Icons/HorizontalOutputIcon';

type Props = {
  width: number;
  height: number;
};

// function greatestCommonDivisor(a: number, b: number): number {
//   return b == 0 ? a : greatestCommonDivisor(b, a % b);
// }

// function getAspectRatio(width: number, height: number) {
//   // Function to calculate the greatest common divisor (GCD) of two numbers

//   // Calculate the GCD of the width and height
//   const divisor = greatestCommonDivisor(width, height);

//   // Divide both width and height by the GCD to simplify the ratio
//   const simplifiedWidth = width / divisor;
//   const simplifiedHeight = height / divisor;

//   // Return the aspect ratio as a string
//   return `${simplifiedWidth}/${simplifiedHeight}`;
// }

const Root = styled('div', {
  color: '$textPrimary70',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  // bgc: '$uiQuaternary',

  variants: {
    isVertical: {
      true: {
        maxHeight: '0.875rem',
        width: 'auto',
      },
      false: {
        maxWidth: '0.875rem',
        height: 'auto',
      },
    },
  },
});

export function AspectRatio({ width, height }: Props) {
  const isVertical = height > width;

  return (
    <Tooltip delayDuration={0}>
      <TooltipTrigger asChild>
        {/* <Root style={{ aspectRatio }} isVertical={isVertical} /> */}
        <Root>{isVertical ? <VerticalOutputIcon size="xs" /> : <HorizontalOutputIcon size="xs" />}</Root>
      </TooltipTrigger>
      <TooltipContent css={{ maxWidth: 120, textAlign: 'center' }}>
        {isVertical ? 'Vertical' : 'Horizontal'}
      </TooltipContent>
    </Tooltip>
  );
}
